export type AuthReason = "list" | "request" | "fulfill" | "book" | "ask" | "chat" | "cart" | "wishlist";

/** Build an /auth URL that returns the user to `next` (defaults to current page). */
export const authUrl = (reason?: AuthReason, next?: string) => {
  const target = next ?? `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const params = new URLSearchParams();
  if (target && target !== "/auth") params.set("next", target);
  if (reason) params.set("reason", reason);
  const qs = params.toString();
  return qs ? `/auth?${qs}` : "/auth";
};
